/* CG v1: one lightweight intersection observer for subtle, accessible section reveals. */
(()=>{
  if(document.body.dataset.motion!=='true'||!('IntersectionObserver' in window)
     ||window.matchMedia('(prefers-reduced-motion: reduce)').matches
     ||window.Shopify?.designMode)return;
  const selectors=[
    '.hero-copy','.hero-visual',
    '.section-heading','.category-card','.product-card',
    '.story-panel','.newsletter','.cg-home-trust-heading','.cg-home-trust-card',
    '.page-heading','.product-layout>.gallery','.product-layout>.product-detail',
    '.collection-chips','.catalog-toolbar','.search-form','.contact-form',
    '.footer-top>div'
  ];
  const nodes=[...document.querySelectorAll(selectors.join(','))];
  if(!nodes.length)return;
  const observer=new IntersectionObserver((entries,obs)=>{
    for(const entry of entries){
      if(entry.isIntersecting){
        entry.target.classList.add('cg-visible');
        obs.unobserve(entry.target);
      }
    }
  },{threshold:.05,rootMargin:'0px 0px 35px 0px'});
  const siblingClasses=new Set(['category-card','product-card','cg-home-trust-card']);
  nodes.forEach(node=>{
    const parent=node.parentElement;
    const group=[...node.classList].find(c=>siblingClasses.has(c));
    let position=0;
    if(group&&parent)position=[...parent.children].filter(el=>el.classList.contains(group)).indexOf(node);
    node.style.setProperty('--cg-delay',Math.min(position%4,3)*70+'ms');
    node.classList.add('cg-reveal');
    observer.observe(node);
  });
})();
